var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "url(#paint0_linear_310_335)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14802 17.8099C13.3954 15.5237 16.8945 14.0165 18.6452 13.2883C23.644 11.2092 24.6827 10.848 25.3597 10.8361C25.5086 10.8334 25.8416 10.8703 26.0572 11.0453C26.2393 11.1931 26.2894 11.3927 26.3134 11.5328C26.3374 11.6729 26.3672 11.992 26.3435 12.2414C26.0726 15.0876 24.9005 21.9947 24.3042 25.1825C24.0519 26.5314 23.555 26.9836 23.0741 27.0279C22.0288 27.1241 21.235 26.3371 20.2226 25.6735C18.6384 24.635 17.7434 23.9885 16.2056 22.9751C14.4284 21.804 15.5805 21.1603 16.5933 20.1084C16.8584 19.8331 21.4639 15.644 21.5531 15.264C21.5642 15.2164 21.5746 15.0393 21.4693 14.9457C21.3641 14.8522 21.2087 14.8842 21.0966 14.9096C20.9378 14.9457 18.4069 16.6184 13.5041 19.928C12.7858 20.4212 12.1351 20.6616 11.5521 20.649C10.9094 20.6351 9.67314 20.2856 8.75409 19.9869C7.62684 19.6204 6.73092 19.4267 6.80893 18.8044C6.84957 18.4803 7.29593 18.1488 8.14802 17.8099Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_335",
    x1: 1800,
    y1: 0,
    x2: 1800,
    y2: 3573.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.69d087584861f8f8a31530a9966970dc.svg";
export { ForwardRef as ReactComponent };